var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.keywords)?_c('div',{staticClass:"keywords"},[_c('span',[_vm._v("搜索关键词：")]),_c('span',{staticClass:"keywords-value"},[_c('span',[_vm._v(_vm._s(_vm.keywords))]),_c('i',{staticClass:"el-icon-close keywords-close",on:{"click":_vm.onCloseClick}})])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }